import {
  AddPhotoAlternate,
  BookmarkAdd,
  TurnedIn,
  TurnedInNot,
  ZoomIn
} from '@mui/icons-material'
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  CircularProgress,
  Fade,
  Hidden,
  Icon,
  IconButton,
  ImageList,
  ImageListItem,
  Paper,
  Popover,
  Typography
} from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import React from 'react'
import { connect } from 'react-redux'
import { NivosEvents } from 'components'
import { NivosGalleryItem } from 'components/amenity-booking'
import CreateAmenity from 'components/amenity-booking/create-amenity'
import CreateReservation from 'components/amenity-booking/create-reservation'
import NivosModal from 'components/nivos-modal'
import NivosRTE from 'components/nivos-rte'
import { AMENITY_ADMIN_PERMISSION_CODES } from 'constants/permissions'
import {
  Operations as AmenityBookingOperations,
  operations as amenityBookingOperations
} from 'states/dux/amenity-booking/operations'
import { Payload as AmenityBookingPayload } from 'states/dux/amenity-booking/types'
import {
  Operations as AmenityOperations,
  operations as amenityOperations
} from 'states/dux/amenity/operations'
import { Payload as AmenityPayload } from 'states/dux/amenity/types'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import {
  Operations as UserOperations,
  operations as userOperations
} from 'states/dux/user/operations'
import { Payload as UserPayload } from 'states/dux/user/types'
import State from 'states/types'
import { Amenity } from 'types/amenity-booking'
import {
  get,
  mapOperationsToDispatchProps,
  objectifyDateStringFields
} from 'utils/common'
import { hasPermissions } from 'utils/user'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
  amenity: AmenityPayload
  user: UserPayload
  amenityBooking: AmenityBookingPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
    amenity: AmenityOperations
    user: UserOperations
    amenityBooking: AmenityBookingOperations
  }
}

type RowColType = Array<[number, number]>

type AppProps = StateProps & DispatchProps

const AmenityBookingFC: React.FC<any> = (props: AppProps) => {
  const { layout, theme, operations, amenity, amenityBooking, user } = props
  const [show, setShow] = React.useState(false)
  const isMobileView = useMediaQuery('(max-width:600px)')
  const [mobileSelectedAmenity, setSelectedAmenity] = React.useState<Amenity>()
  const [rowColCycle, setRowColCycle] = React.useState<RowColType>([
    [2, 2],
    [2, 2]
  ])

  const myBookingBtn = React.useRef(null)

  const _getGalleryItemRowCol = (
    length: number,
    index: number
  ): [number, number] => {
    if (length <= 2) {
      return [4, 2]
    } else if (length === 3) {
      return [index === 0 ? 4 : 2, 2]
    } else {
      return [index === 0 ? 4 : 2, index === 0 || index === 3 ? 2 : 1]
    }
  }

  const _getRowColArr = (data: any[]): RowColType => {
    let returnArr: RowColType = []
    let counter = 1
    const _length = data.length + 1

    while (_length - (counter - 1) * 4 > 0) {
      const temp = data.filter(
        (item, index) => index < counter * 4 && index >= (counter - 1) * 4
      )
      const temp2 = temp.map((_, index) =>
        _getGalleryItemRowCol(temp.length, index)
      )

      returnArr = returnArr.concat(temp2)
      counter++
    }

    return returnArr
  }

  const _handleRowCol = (list: any[]): void => {
    const length = list.length + 1
    if (length <= 4) {
      const cycle = list.map((_, index) => _getGalleryItemRowCol(length, index))
      cycle.push(_getGalleryItemRowCol(length, length - 1))
      setRowColCycle(cycle)
    } else {
      setRowColCycle(_getRowColArr(list))
    }
  }

  React.useEffect(() => {
    // Fetch available amenities
    if (amenity.data.length < 1) {
      operations.amenity.loading(true)
      void get('/booking/items/amenity/').then((data: Amenity[]) => {
        _handleRowCol(data)
        operations.amenity.set(data)
        operations.amenity.loading(false)
      })
    } else {
      _handleRowCol(amenity.data)
    }

    // Fetch amenity bookings
    if (amenityBooking.data.length < 1) {
      operations.amenityBooking.loading(true)
      void get('/booking/amenity/').then(data => {
        const parsedData = data.map((item: any) =>
          objectifyDateStringFields(item)
        )
        operations.amenityBooking.set(parsedData)
        operations.amenityBooking.loading(false)
      })
    }
  }, [])

  React.useEffect(() => {
    _handleRowCol(amenity.data)
  }, [amenity])

  const AddAmenityButton: React.FC = () => {
    const [addHovered, setHovered] = React.useState(false)
    const [openCreate, setOpenCreate] = React.useState(false)

    // Creation states

    return (
      <>
        <CreateAmenity open={openCreate} setOpen={setOpenCreate} />
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'center'}
          height={0.99}
          width={0.99}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          onClick={() => setOpenCreate(true)}
          sx={{
            cursor: 'pointer',
            transition: '0.5s',
            fontSize: addHovered ? 64 : 48
          }}
        >
          <Box display={'flex'} width={0.99}>
            <Box
              width={45}
              height={45}
              borderLeft={5}
              borderTop={5}
              borderRadius={'4px'}
              borderColor={theme.secondaryColor}
              sx={{ transition: '0.5s' }}
              margin={addHovered ? 2 : 1}
            />
            <Box flexGrow={1} />
            <Box
              width={45}
              height={45}
              borderRight={5}
              borderTop={5}
              borderRadius={'4px'}
              borderColor={theme.secondaryColor}
              sx={{ transition: '0.5s' }}
              margin={addHovered ? 2 : 1}
            />
          </Box>
          <Box
            flexGrow={1}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Icon fontSize={'inherit'}>
              <AddPhotoAlternate fontSize={'inherit'} />
            </Icon>
          </Box>
          <Box display={'flex'} width={0.99}>
            <Box
              width={45}
              height={45}
              borderLeft={5}
              borderBottom={5}
              borderRadius={'4px'}
              borderColor={theme.secondaryColor}
              sx={{ transition: '0.5s' }}
              margin={addHovered ? 2 : 1}
            />
            <Box flexGrow={1} />
            <Box
              width={45}
              height={45}
              borderRight={5}
              borderBottom={5}
              borderRadius={'4px'}
              borderColor={theme.secondaryColor}
              sx={{ transition: '0.5s' }}
              margin={addHovered ? 2 : 1}
            />
          </Box>
        </Box>
      </>
    )
  }

  return (
    <Fade in={true} timeout={1000}>
      <Box
        id={'container'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        width={'100%'}
        padding={isMobileView ? 0 : 2}
        sx={{ transition: '.5s' }}
      >
        <Popover
          open={show}
          onClose={() => setShow(false)}
          anchorEl={myBookingBtn.current}
          elevation={8}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          sx={{ marginTop: 1 }}
        >
          <Paper elevation={8} sx={{ width: 1, zIndex: 100 }}>
            <Box
              width={380}
              display={'flex'}
              alignItems={'center'}
              justifyContent={'center'}
            >
              {amenityBooking.loading && <CircularProgress />}
              {!amenityBooking.loading && (
                <NivosEvents
                  events={amenityBooking.data.map(item => {
                    return {
                      eventName: item.amenity.name,
                      description: item.amenity.description,
                      date: item.fromDate
                    }
                  })}
                  header={layout.language.translations.myBookings}
                />
              )}
            </Box>
          </Paper>
        </Popover>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          alignItems={'flex-end'}
          alignSelf={'flex-end'}
          style={{
            transition: '.5s',
            position: 'sticky',
            top: '60px',
            zIndex: 100
          }}
          width={400}
          marginRight={isMobileView ? 0 : -2}
        >
          <Button
            ref={myBookingBtn}
            variant={'contained'}
            startIcon={
              !show ? (
                <TurnedInNot fontSize={'large'} />
              ) : (
                <TurnedIn fontSize={'large'} />
              )
            }
            size={'large'}
            onClick={() => setShow(!show)}
            sx={{
              zIndex: 100,
              transition: '.5s',
              borderTopRightRadius: 0,
              borderBottomRightRadius: 0
            }}
          >
            {layout.language.translations.myBookings}
          </Button>
        </Box>
        <Hidden mdDown>
          <Box
            width={1}
            display={'flex'}
            justifyContent={'center'}
            alignItems={'center'}
          >
            {!amenity.loading && amenity.data.length > 0 && (
              <ImageList
                sx={{ width: 0.9 }}
                variant="quilted"
                cols={4}
                rowHeight={121}
              >
                {amenity.data.map((amenity, index) => {
                  let idx = index
                  if (index > rowColCycle.length - 1) {
                    idx =
                      rowColCycle.length *
                        Math.ceil(index / rowColCycle.length) -
                      index
                  }
                  const row = rowColCycle[idx][0]
                  const col = rowColCycle[idx][1]

                  return (
                    <NivosGalleryItem
                      amenity={amenity}
                      rows={row}
                      cols={col}
                      key={index}
                    />
                  )
                })}
                {hasPermissions(user, AMENITY_ADMIN_PERMISSION_CODES) && (
                  <ImageListItem
                    rows={rowColCycle[rowColCycle.length - 1][0]}
                    cols={rowColCycle[rowColCycle.length - 1][1]}
                  >
                    <AddAmenityButton />
                  </ImageListItem>
                )}
              </ImageList>
            )}
            {amenity.loading && <CircularProgress />}
          </Box>
        </Hidden>
        <Hidden mdUp>
          <NivosModal
            title={'Nivos'}
            open={mobileSelectedAmenity !== undefined}
            setOpen={_ => setSelectedAmenity(undefined)}
          >
            <>
              {mobileSelectedAmenity !== undefined && (
                <CreateReservation
                  selectedAmenity={mobileSelectedAmenity}
                  handleClose={() => setSelectedAmenity(undefined)}
                />
              )}
            </>
          </NivosModal>
          {!amenity.loading && amenity.data.length > 0 && (
            <Box
              display={'flex'}
              flexWrap={'wrap'}
              justifyContent={'center'}
              width={1}
              minHeight={'100vh'}
            >
              {amenity.data.map((amenityItem, index) => (
                <Box key={index} width={350} margin={1}>
                  <Card elevation={8}>
                    <CardHeader
                      title={amenityItem.name}
                      subheader={
                        amenityItem.bookable ? 'Available' : 'Not available'
                      }
                      action={
                        <IconButton
                          onClick={() => setSelectedAmenity(amenityItem)}
                        >
                          {amenityItem.bookable && (
                            <BookmarkAdd color={'inherit'} />
                          )}
                          {!amenityItem.bookable && (
                            <ZoomIn color={'inherit'} />
                          )}
                        </IconButton>
                      }
                    />
                    <CardMedia
                      component={'img'}
                      height={'194px'}
                      image={amenityItem.images[0].url}
                      alt={amenityItem.images[0].name}
                    />
                    <CardContent>
                      <Box height={80}>
                        {(amenityItem.descriptionRte === null ||
                          amenityItem.descriptionRte.trim() === '') && (
                          <Typography
                            sx={{
                              display: '-webkit-box',
                              WebkitLineClamp: 4,
                              WebkitBoxOrient: 'vertical',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {amenityItem.description}
                          </Typography>
                        )}
                        {amenityItem.descriptionRte !== null &&
                          amenityItem.descriptionRte.trim() !== '' && (
                            <NivosRTE
                              rteState={amenityItem.descriptionRte}
                              setRteState={_ => null}
                              readOnly={true}
                              containerProps={{ color: 'white' }}
                            />
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              ))}
            </Box>
          )}
        </Hidden>
      </Box>
    </Fade>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout,
    amenity: state.amenity,
    user: state.user,
    amenityBooking: state.amenityBooking
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations,
  amenity: amenityOperations,
  user: userOperations,
  amenityBooking: amenityBookingOperations
})

const AmenityBooking = connect(
  mapStateToProps,
  mapDispatchToProps
)(AmenityBookingFC)

export default AmenityBooking
